import React from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../i18n';
import { confirmOABPayment } from '../RopPayment/services/ropPaymentService';


// Target of CLIENT_CANCELLED_URL. Marks the pending `payments` row(s) as
// failed via the same idempotent confirm endpoint, so they don't sit
// pending forever if the user backs out of OAB.
export class RopPaymentCancelled extends React.Component {
  constructor(props) {
    super(props);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // `mzref` — not `ref`, see RopPayModal/RopPaymentSuccess for why.
    this.state = { reference: params.mzref };
  }

  componentDidMount() {
    if (this.state.reference) {
      confirmOABPayment({
        reference: this.state.reference,
        status: 'failed',
      }).catch((error) => {
        console.error('Error marking online payment failed:', error);
      });
    }
  }

  render() {
    const { reference } = this.state;
    return (
      <React.Fragment>
        <section>
          <div
            className="bannerimg cover-image sptb-2"
            data-image-src="../assets/images/banners/banner2.jpg"
          >
            <div className="header-text mb-0">
              <div className="container">
                <div className="text-center text-white ">
                  <h1 className="">Payment Cancelled</h1>
                  <ol className="breadcrumb text-center">
                    <li className="breadcrumb-item">
                      <Link exact="true" to="/">
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active text-white" aria-current="page">
                      <Link exact="true" to="/rop">
                        {i18n.t('auction')}
                      </Link>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sptb">
          <div className="container">
            <div className="container text-center">
              <div className="display-1 mb-5"></div>
              <h1 className="h2 mb-3">Payment Cancelled</h1>
              <p className="h4 font-weight-Automatic mb-8 leading-Automatic">
                Oops!!!! Your payment process is cancelled
              </p>
              {reference && <p className="text-muted small">Reference: {reference}</p>}
              <Link className="btn btn-warning" to="/">
                {i18n.t('back')}
              </Link>
              <p className="h4 font-weight-Automatic mb-8 leading-Automatic">
                Please try again to complete your auction payment.
              </p>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}